import {
  Button,
  Checkbox,
  CheckboxGroup,
  Form,
  Loader,
  Placeholder,
  Progress,
  Radio,
  RadioGroup,
} from "rsuite";
import axios from "axios";
import posthog from "posthog-js";
import { isArray } from "chart.js/helpers";
import CloseIcon from "@rsuite/icons/Close";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import AuthService from "../../services/auth.service";
import MessageHandle from "../../services/MessageHandle";
import ConfirmedSaveModal from "../panel/elements/modals/confirmedSaveModal";

import BackIcon from "../../img/back.svg";
import male_logo from "./../../../src/img/male.png";
import female_logo from "./../../../src/img/female.png";

import "./regime_form.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const RegimeForm = () => {
  const [containerClass, setContainerClass] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [hasUserForm, setHasUserForm] = useState(0);

  const [confirmedModal, setConfirmedModal] = useState(false);

  let ans = [];

  useEffect(() => {
    getFormData();
    localStorage.removeItem("update");
    let regimeFormOld = null;
    try {
      regimeFormOld = JSON.parse(localStorage.getItem("regime_form_old"));
    } catch (exception) {
      localStorage.removeItem("regime_form_old");
    }
    if (regimeFormOld && !isArray(regimeFormOld)) {
      if (typeof regimeFormOld === "object") {
        changeOldToNewVersion(regimeFormOld);
      } else {
        localStorage.removeItem("regime_form_old");
      }
    }

    setAnswers(JSON.parse(localStorage.getItem("regime_form_old")) ?? []);
  }, []);

  window.addEventListener("popstate", function (event) {
    handleBrowserBack();
  });
  const [answers, setAnswers] = useState(ans);

  return (
    <div
      className={`regime-form-container regime-form container ${containerClass} s-${
        currentStep + 1
      }`}
    >
      <div className="regime-form-bs-dismiss ">
        {formData?.has_user_form ? closeButton() : <></>}
      </div>
      <div className="form-container">
        <div className="regime-form-progress-bar">
          <Progress.Line
            percent={
              formData ? ((currentStep + 1) * 100) / formData.steps.length : 0
            }
            strokeColor="#F5921F"
            showInfo={false}
          />
          <div className="regime-form-step-counter">
            {formData ? `${currentStep + 1}/${formData.steps.length}` : ""}
          </div>
        </div>

        {formData ? (
          renderFormData(currentStep)
        ) : (
          <>
            <Placeholder.Paragraph rows={8} />
            <Loader backdrop content="درحال بارگذاری ..." vertical />
          </>
        )}
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <ConfirmedSaveModal
        title={"  تغییرات رو ذخیره کنیم؟"}
        handleSave={handleSave}
        handleCancel={handleCancel}
        setConfirmedModal={setConfirmedModal}
        confirmedModal={confirmedModal}
      />
    </div>
  );

  function changeOldToNewVersion(regimeFormOld) {
    const queryParams = [
      {
        name: "weight",
        value: regimeFormOld.weight,
      },
      {
        name: "height",
        value: regimeFormOld.height,
      },
      {
        name: "gender",
        value: regimeFormOld.gender,
      },
      { name: "age", value: regimeFormOld.age },
    ];
    localStorage.setItem("regime_form_old", JSON.stringify(queryParams));
  }

  function handleCancel() {
    window.location.replace("/");
  }

  function handleSave() {
    setConfirmedModal(false);
    save();
  }

  function onBlur() {
    setContainerClass("");
  }

  function onFocus() {
    setContainerClass("on-keyboard");
  }

  function renderFormData(index) {
    const { steps } = formData;
    const theStep = steps[index];

    return (
      <>
        {index > 0 ? backButton() : ""}
        <div className={`regime-form ${theStep.style ? theStep.style : ""}`}>
          {theStep.title ? (
            <div className="text-primary">{theStep.title}</div>
          ) : (
            ""
          )}
          <div style={{ marginTop: "2rem" }}>
            {theStep.questions.map((question, questionIndex) => {
              let view = null;
              if (question.type === "radio") {
                view = (
                  <RadioGroup
                    name={question?.name}
                    value={
                      getAnswerValueByName(question?.name)
                        ? getAnswerValueByName(question?.name)
                        : null
                    }
                    onChange={(value, event) =>
                      updateAnswer(event, question.type)
                    }
                    className={question.style}
                  >
                    {question.options.map((option, optionIndex) => {
                      return (
                        <div key={optionIndex}>
                          <Radio
                            className="d-block"
                            value={option.id.toString()}
                            key={optionIndex}
                          >
                            <div className="option-title">
                              {question?.name === "gender" &&
                              option.id === 1 ? (
                                <img className="ml-1" alt="" src={male_logo} />
                              ) : (
                                ""
                              )}
                              {question?.name === "gender" &&
                              option.id === 2 ? (
                                <img
                                  className="ml-1"
                                  alt=""
                                  src={female_logo}
                                />
                              ) : (
                                ""
                              )}
                              {option.title}
                            </div>
                            <div className="option-content">
                              {option.content}
                            </div>
                          </Radio>
                        </div>
                      );
                    })}
                  </RadioGroup>
                );
              } else if (question.type === "checkbox") {
                view = (
                  <CheckboxGroup
                    name={question?.name}
                    value={
                      getAnswerValueByName(question?.name)
                        ? getAnswerValueByName(question?.name)
                        : []
                    }
                    className={question.style}
                  >
                    {question.options.map((option, optionIndex) => {
                      return (
                        <Checkbox
                          className="d-block"
                          onChange={(value, checked, event) =>
                            updateAnswer(event, question.type, checked)
                          }
                          value={option.id.toString()}
                          key={optionIndex}
                        >
                          <div className="option-title">{option.title}</div>
                          <div className="option-content">{option.content}</div>
                        </Checkbox>
                      );
                    })}
                  </CheckboxGroup>
                );
              } else if (question.type === "text") {
                view = (
                  <Form name={question?.name} className={question.style}>
                    {question.options.map((option, optionIndex) => {
                      return (
                        <Form.Group
                          controlId={option?.name}
                          className="d-block"
                          key={`${index}-${questionIndex}-${optionIndex}`}
                        >
                          <Form.ControlLabel>{option.title}</Form.ControlLabel>
                          <Form.Control
                            name={option?.name}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            onKeyDown={(e) =>
                              e.key === "Enter" ? handleNext() : null
                            }
                            autoFocus={
                              option.auto_focus ? option.auto_focus : false
                            }
                            inputMode={
                              option.input_mode ? option.input_mode : "text"
                            }
                            value={
                              getAnswerValueByName(option?.name)
                                ? getAnswerValueByName(option?.name)
                                : ""
                            }
                            onChange={(value, event) =>
                              updateAnswer(
                                event,
                                question.type,
                                true,
                                option.input_mode
                              )
                            }
                          />
                        </Form.Group>
                      );
                    })}
                  </Form>
                );
              }

              return (
                <div key={index + "-" + questionIndex}>
                  <p className="question-title">{question.title}</p>
                  {view}
                </div>
              );
            })}
          </div>
        </div>

        <div className="form-bottom">
          <Button
            appearance={isLoading ? "default" : "primary"}
            loading={isLoading}
            onClick={handleNext}
            className={`btn-step-${currentStep + 1} hf-${hasUserForm}`}
            block
          >
            ادامه
          </Button>
        </div>
      </>
    );
  }

  function updateAnswer(event, type, checked = true, inputMode = null) {
    localStorage.setItem("update", true);
    if (inputMode !== "text") {
      if (isNaN(event.target.value)) {
        event.target.value = "";
        toast.error("لطفا عدد وارد کنید", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }

    const { name } = event.target;
    const { value } = event.target;

    let currentAnswers = [...answers];
    const targetIndex = currentAnswers.findIndex(
      (answer) => answer.name === name
    );
    const targetAnswer = currentAnswers[targetIndex];

    let answer = {};
    answer.name = name;

    if (type === "checkbox") {
      if (targetAnswer) {
        answer.value = targetAnswer.value;
      } else {
        answer.value = [];
      }

      if (checked) {
        answer.value.push(value);
      } else {
        answer.value = answer.value.filter((val) => val !== value).flat();
      }
    } else {
      answer.value = value;
    }

    if (targetAnswer) {
      currentAnswers[targetIndex] = answer;
    } else {
      currentAnswers.push(answer);
    }

    setAnswers(currentAnswers);

    localStorage.setItem("regime_form_old", JSON.stringify(currentAnswers));

    return currentAnswers;
  }

  function getFormData(force = false) {
    if (formData && !force) {
      return formData;
    }
    let config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
    };

    const height = answers.find((answer) => answer.name === "height");
    const weight = answers.find((answer) => answer.name === "weight");
    const age = answers.find((answer) => answer.name === "age");

    let body = {};

    if (height) {
      body = {
        height: height.value,
        weight: weight.value,
        age: age.value,
      };
    }

    config.params = body;

    setIsLoading(true);

    axios
      .get(`${APP_URL}/api/v6/user-forms/create`, config)
      .then(function (response) {
        setFormData(response.data.data);
        ans = response.data.data?.answers;
        if (localStorage.getItem("regime_form_old")) {
          setAnswers(JSON.parse(localStorage.getItem("regime_form_old")));
        } else {
          setAnswers(ans);
        }

        if (response.data.data.has_user_form) {
          addUrlParameter("hf", 1);
          setHasUserForm(1);
        } else {
          addUrlParameter("hf", 0);
          setHasUserForm(0);
        }

        if (force) {
          handleNext(false);
        }

        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        if (!error.response) {
          handleNotfound();
          return false;
        }
        MessageHandle.error(error);
      });
  }

  function save() {
    if (isLoading) {
      return false;
    }

    const config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
    };

    let body = {};

    for (const answer of answers) {
      body[answer.name] = answer.value;
    }

    setIsLoading(true);

    axios
      .post(`${APP_URL}/api/v6/user-forms`, body, config)
      .then(function (response) {
        const type = getUrlParameter("type") ?? 0;
        if (type === 0) {
          posthog?.capture("regime-form-completion-irancell");
        } else {
          posthog?.capture("regime-form-completion");
        }
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        localStorage.removeItem("regime_form_old");
        localStorage.removeItem("update");
        const urlParams = new URLSearchParams(window.location.search);

        window.location.replace(
          urlParams.get("backUrl") ? urlParams.get("backUrl") : "/"
        );
      })
      .catch(function (error) {
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();
          return false;
        }
        MessageHandle.error(error);
      });
  }

  function backButton() {
    return (
      <button className="btn-back" onClick={handleBack}>
        <img src={BackIcon} alt="back" style={{ width: "20px" }} />
      </button>
    );
  }

  function closeButton() {
    return (
      <button className="regime-form-btn-close" onClick={handleClose}>
        <CloseIcon />
      </button>
    );
  }

  function handleClose() {
    if (localStorage.getItem("update")) {
      //<ConfirmedSaveModal/>
      localStorage.removeItem("regime_form_old");
      setConfirmedModal(true);
      return true;
    } else window.location.replace("/dashboard");
  }

  function handleBrowserBack() {
    if (currentStep - 1 >= 0) {
      setContainerClass("");
      setCurrentStep(currentStep - 1);
    }
  }

  function handleBack() {
    setContainerClass("");

    const indexes = Object.keys(formData.steps).map((index) => parseInt(index));
    const prevStep = currentStep - 1;

    if (indexes.includes(prevStep)) {
      setCurrentStep(prevStep);
    }
  }

  function handleNext(force = true) {
    setContainerClass("");

    if (!validateStep(currentStep)) {
      return false;
    }
    let nextStep = null;

    const currentStepKey = formData.steps[currentStep].key;

    if (currentStepKey === "physical-step" && force) {
      getFormData(true);
    } else {
      const indexes = Object.keys(formData.steps).map((index) =>
        parseInt(index)
      );

      nextStep = currentStep + 1;

      if (
        formData.steps[currentStep + 1] &&
        formData.steps[currentStep + 1].key === "target-level-step"
      ) {
        const weight = parseFloat(
          answers.find((answer) => answer.name === "weight").value
        ).toFixed(2);
        const target_weight = parseFloat(
          answers.find((answer) => answer.name === "target_weight").value
        ).toFixed(2);
        if (weight === target_weight) {
          nextStep = nextStep + 1;
        }
      }
      if (nextStep >= formData.steps.length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_completion",
          step: nextStep,
          has_form: hasUserForm,
          type: getUrlParameter("type") ?? 0,
        });
        save();
        return true;
      }

      if (indexes.includes(nextStep)) {
        setCurrentStep(nextStep);
        addUrlParameter("s", nextStep);
        localStorage.setItem("regime_form_step", nextStep.toString());

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_step_change",
          step: nextStep,
          has_form: hasUserForm,
          type: getUrlParameter("type") ?? 0,
        });
      }
    }
  }

  function validateStep(stepIndex) {
    const requiredQuestions = formData.steps[stepIndex].questions
      .filter((question) => question.required)
      .flat();

    let valid = true;

    if (requiredQuestions.length > 0) {
      for (const requiredQuestion of requiredQuestions) {
        if (!getAnswerValueByName(requiredQuestion?.name)) {
          if (requiredQuestion.required_message) {
            MessageHandle.error(requiredQuestion.required_message);
            valid = false;
            break;
          }
          MessageHandle.error(`${requiredQuestion.title} ضروری است. `);
          valid = false;
          break;
        }
      }
    }

    if (valid === true) {
      const requiredOptions = formData.steps[stepIndex].questions
        .map((question) => question.options)
        .flat()
        .filter((option) => option.required)
        .flat();
      for (const requiredOption of requiredOptions) {
        if (!getAnswerValueByName(requiredOption?.name)) {
          if (requiredOption.required_message) {
            MessageHandle.error(requiredOption.required_message);
            valid = false;
            break;
          } else {
            MessageHandle.error(`${requiredOption.title} ضروری است. `);
            valid = false;
            break;
          }
        }
      }
    }

    if (valid === true) {
      const validationOptions = formData.steps[stepIndex].questions
        .map((question) => question.options)
        .flat()
        .filter((option) => {
          return option.validation;
        })
        .flat();

      for (const validationOption of validationOptions) {
        const answer = getAnswerValueByName(validationOption?.name);
        const validation = validationOption.validation;

        if (answer < validation.min || answer > validation.max) {
          MessageHandle.error(
            ` وزن هدف باید بین${validation.min} تا ${validation.max} کیلوگرم باشد`
          );
          valid = false;
          break;
        }

        // if (validation.min && answer < validation.min) {
        //     toast.error(`${validationOption.replace} نباید کمتر از ${validation.min} باشد. `, {
        //         position: "top-right",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "light",
        //     });
        //
        //     valid = false;
        // }

        // if (validation.max && answer > validation.max) {
        //     toast.error(`${validationOption.replace} نباید بزرگتر از ${validation.max} باشد. `, {
        //         position: "top-right",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "light",
        //     });
        //
        //     valid = false;
        // }
      }
    }
    return valid;
  }

  function getAnswerValueByName(name) {
    const index = answers.findIndex((answer) => answer.name === name);
    if (index >= 0) {
      try {
        if (answers[index].value) {
          if (Array.isArray(answers[index].value)) {
            return answers[index].value;
          }

          return answers[index].value.toString();
        } else {
          return "";
        }
      } catch (exception) {
        return answers[index].value;
      }
    }

    return false;
  }

  function addUrlParameter(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    let kvp = window.location.search.substr(1).split("&");
    if (kvp[0] === "") {
      const path =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        key +
        "=" +
        value;
      window.history.pushState({ path: path }, "", path);
    } else {
      let i = kvp.length;
      let x;
      while (i--) {
        x = kvp[i].split("=");

        if (x[0] === key) {
          x[1] = value;
          kvp[i] = x.join("=");
          break;
        }
      }

      if (i < 0) {
        kvp[kvp.length] = [key, value].join("=");
      }

      const refresh =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        kvp.join("&");
      window.history.pushState({ path: refresh }, "", refresh);
    }
  }

  function getUrlParameter(key) {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  }

  function handleNotfound() {
    localStorage.removeItem("regime_form_old");
    localStorage.removeItem("update");
    localStorage.setItem("error", "PageNotFound");
    setIsLoading(false);
    window.location.href = "";
  }
};

export default RegimeForm;
